// Kicksociety hero carousel (server-rendered markup in sections/ks-hero.liquid).
// Autoplay pauses only while the pointer rests on the shoe/controls, while a control has keyboard focus,
// or for 6 s after a touch; off with prefers-reduced-motion. The pause/play button holds it until pressed
// again (WCAG 2.2.2). Arrows, swipe/drag and arrow keys.
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const ARROW = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';

  function init(hero) {
    if (hero.dataset.ready) return;
    hero.dataset.ready = '1';
    const stage = hero.querySelector('[data-ks-stage]');
    if (!stage) return;
    const slides = [...stage.querySelectorAll('.ks-slide')];
    const n = slides.length;
    const $ = s => hero.querySelector(s);
    const prog = $('[data-prog]');
    let cur = 0, touchTimer;

    const positions = () => slides.forEach((s, k) => {
      const d = (k - cur + n) % n;
      let pos = 'x';
      if (d === 0) pos = 0; else if (d === 1) pos = 1; else if (d === n - 1) pos = -1;
      else if (d === 2 && n > 4) pos = 2; else if (d === n - 2 && n > 4) pos = -2;
      s.dataset.pos = pos;
      s.setAttribute('aria-hidden', pos !== 0);
      if (pos === 0) {                                  // floor shadow follows the active shoe
        const im = s.querySelector('img');
        stage.style.setProperty('--fy', im?.dataset.fy || .8);
        stage.style.setProperty('--fw', im?.dataset.fw || .55);
      }
    });
    const highlight = () => {
      hero.querySelectorAll('.ks-rail__item[data-slide]').forEach(a => a.classList.toggle('is-active', +a.dataset.slide === cur));
      hero.querySelectorAll('.ks-rail__sub').forEach(x => x.classList.toggle('is-open', +x.dataset.for === cur));
      const chip = hero.querySelector(`.ks-rail__item[data-slide="${cur}"]`), rail = hero.querySelector('.ks-rail');
      if (chip && rail.scrollWidth > rail.clientWidth) rail.scrollTo({ left: chip.offsetLeft - rail.offsetLeft - 16, behavior: reduced ? 'auto' : 'smooth' });
    };
    const copy = animate => {
      const d = slides[cur].dataset;
      const apply = () => {
        $('[data-kick]').textContent = `${d.colTitle} · ${d.colCount} pairs`;
        const t = $('[data-title]'); t.textContent = d.model; t.style.setProperty('--chars', Math.max(5, d.model.length));
        $('.ks-hero__sub').innerHTML = `${esc(d.sub)}<span class="sep">|</span>${esc(d.price)}`;
        $('[data-see]').href = d.url;
        const shop = $('[data-shop]'); shop.href = d.colUrl; shop.innerHTML = `Shop ${esc(d.colTitle.toLowerCase())} ${ARROW}`;
        const grid = $('[data-grid]'); if (grid) grid.href = d.colUrl;
        $('[data-num]').textContent = String(cur + 1).padStart(2, '0');
      };
      const masks = [...hero.querySelectorAll('.ks-mask')];
      if (!animate || reduced) { apply(); return; }
      masks.forEach(m => m.classList.add('is-out'));
      setTimeout(() => { apply(); masks.forEach(m => { m.classList.remove('is-out'); m.classList.add('is-in-start'); m.offsetHeight; m.classList.remove('is-in-start'); }); }, 300);
    };
    const restart = () => { if (!prog || reduced || n < 2) return; prog.classList.remove('run'); prog.offsetWidth; prog.classList.add('run'); };
    const go = (k, animate = true) => { cur = (k + n) % n; positions(); highlight(); copy(animate); restart(); };

    const want = new URLSearchParams(location.search).get('c');
    const startAt = want ? slides.findIndex(s => (s.dataset.colUrl || '').split('/').pop() === want) : -1;
    go(startAt > 0 ? startAt : 0, false);
    if (!reduced) { hero.classList.add('is-enter'); setTimeout(() => hero.classList.remove('is-enter'), 2000); }
    $('[data-prev]').addEventListener('click', () => go(cur - 1));
    $('[data-next]').addEventListener('click', () => go(cur + 1));
    prog?.addEventListener('animationend', () => go(cur + 1));
    hero.querySelectorAll('.ks-rail__item[data-slide]').forEach(a => a.addEventListener('click', e => { e.preventDefault(); go(+a.dataset.slide); }));

    // transient pauses (hover, focus, touch, hidden tab) never override the shopper's own Pause
    let held = false;
    const setPaused = v => hero.classList.toggle('is-paused', v || held);
    const hold = $('[data-pause]');
    hold?.addEventListener('click', () => {
      held = !held;
      hero.classList.toggle('is-held', held);
      hold.setAttribute('aria-label', held ? 'Play slideshow' : 'Pause slideshow');
      setPaused(false);
    });
    const hot = '.ks-slide[data-pos="0"], .ks-hero__ctas, .ks-arrows button, .ks-rail';
    hero.addEventListener('pointerover', e => { if (e.pointerType === 'mouse' && e.target.closest(hot)) setPaused(true); });
    hero.addEventListener('pointerout', e => { if (e.pointerType === 'mouse' && e.target.closest(hot) && !e.relatedTarget?.closest?.(hot)) setPaused(false); });
    hero.addEventListener('focusin', e => { if (e.target.matches(':focus-visible') && !e.target.closest('[data-pause]')) setPaused(true); });
    hero.addEventListener('focusout', () => setPaused(false));
    document.addEventListener('visibilitychange', () => setPaused(document.hidden));

    // swipe / drag; a tap on the active shoe opens the product, on a neighbour moves to it
    let x0 = null, t0 = 0;
    stage.addEventListener('click', e => e.preventDefault());
    stage.addEventListener('pointerdown', e => {
      x0 = e.clientX; t0 = Date.now();
      if (e.pointerType !== 'mouse') { setPaused(true); clearTimeout(touchTimer); touchTimer = setTimeout(() => setPaused(false), 6000); }
    });
    stage.addEventListener('pointerup', e => {
      if (x0 === null) return;
      const dx = e.clientX - x0; x0 = null;
      if (Math.abs(dx) > 50) { go(cur + (dx < 0 ? 1 : -1)); return; }
      if (Date.now() - t0 > 600) return;
      const s = e.target.closest('.ks-slide');
      if (!s) return;
      if (s.dataset.pos === '0') location.href = s.dataset.url;
      else if (s.dataset.pos === '-1') go(cur - 1); else if (s.dataset.pos === '1') go(cur + 1);
    });
    stage.addEventListener('pointercancel', () => (x0 = null));
    hero.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft') go(cur - 1); else if (e.key === 'ArrowRight') go(cur + 1);
    });
  }
  const boot = () => document.querySelectorAll('[data-ks-hero]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', boot);          // theme editor
})();
